<template>
    <v-container fluid>
        <!-- TOOLBAR -->
        <v-toolbar dense color="primary" dark>
            <v-row>
                <v-col cols="4" class="mt-1" align="left">
                    <v-toolbar-title>Gestione Layout</v-toolbar-title>
                </v-col>
                <v-col class="mt-1" cols="4">
                    <v-btn id="changeImg" small light @click="salva()">
                        <v-icon color="success">mdi-floppy</v-icon>
                    </v-btn>
                </v-col>
                <v-col cols="4" class="mt-1" align="right">
                    <v-btn
                        small
                        light
                        @click="$router.push('/home/amministrazione')"
                    >
                        <v-icon color="error">mdi-keyboard-backspace</v-icon>
                    </v-btn>
                </v-col>
            </v-row>
        </v-toolbar>
        <v-row class="d-flex justify-center mt-5">
            <!-- IMMAGINE AZIENDA -->
            <v-col cols="12">Immagine</v-col>
            <v-col cols="12" class="d-flex align-center justify-center pl-15">
                <img
                    @click="cambiaImmagine()"
                    class="tokenImageProfile pointer"
                    v-if="img_azienda != 'undefined'"
                    :src="img_azienda"
                    alt="Quickview"
                />
                <img
                    @click="cambiaImmagine()"
                    class="tokenImageProfile pointer"
                    v-else
                    src="@/assets/logo2.png"
                    alt="Quickview"
                />
                <!-- Cambia Immagine -->
                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            class="mb-5"
                            @click="cambiaImmagine()"
                            rounded
                            v-bind="attrs"
                            v-on="on"
                            small
                        >
                            <v-icon color="primary">mdi-pencil </v-icon>
                        </v-btn>
                    </template>
                    <span>Cambia</span>
                </v-tooltip>
            </v-col>
            <!-- input nome azienda -->
            <v-col cols="4">
                <v-text-field
                    label="Nome azienda"
                    style="width: 400px"
                    v-model="testo_azienda"
                />
            </v-col>
        </v-row>
        <v-container fluid>
            <v-row>
                <v-col cols="2">
                    <v-card min-height="230px" @click="setAppBg">
                        <v-card-title class="d-flex justify-center pb-0">
                            WebApp
                        </v-card-title>

                        <v-icon size="150">mdi-cellphone</v-icon>
                    </v-card>
                </v-col>
                <!-- CARD MODULI -->
                <v-col v-for="(item, i) in moduli" :key="i" cols="2">
                    <v-card min-height="230px" @click="selectModulo(item)">
                        <v-card-title class="d-flex justify-center pb-0">{{
                            item.des_modulo
                        }}</v-card-title>

                        <v-img
                            style="margin: 0 auto; display: block"
                            max-width="100"
                            v-if="item.img_modulo != null"
                            :src="item.img_modulo"
                            height="150"
                            contain
                        />
                        <span v-else>Immagine non trovata</span>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
        <!-- DIALOG MODIFICA IMMAGINE SFONDO MODULO -->
        <v-dialog :key="key_dialog_img_modulo" v-model="dialog_img_modulo">
            <v-card min-height="50vh">
                <v-toolbar color="indigo" dense class="rounded rounded-b-0">
                    <v-toolbar-title class="white--text">
                        Sfondo Modulo
                    </v-toolbar-title>
                    <v-spacer />
                    <!-- SALVA IMMAGINE SFONDO MODULO -->
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                v-bind="attrs"
                                v-on="on"
                                class="my-5 mx-2"
                                small
                                @click="salvaImmagineModulo()"
                            >
                                <v-icon color="success">
                                    mdi-content-save
                                </v-icon>
                            </v-btn>
                        </template>
                        <span>Salva Immagine</span>
                    </v-tooltip>
                    <!-- CARICA NUOVA IMMAGINE SFONDO MODULO -->
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                v-bind="attrs"
                                v-on="on"
                                class="my-5 mx-2"
                                small
                                @click="cambiaImmagineModulo()"
                            >
                                <v-icon color="primary">
                                    mdi-image-edit
                                </v-icon>
                            </v-btn>
                        </template>
                        <span>Cambia Immagine</span>
                    </v-tooltip>
                    <v-spacer />
                    <!-- Chiudi dialog -->
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                v-bind="attrs"
                                v-on="on"
                                small
                                @click="dialog_img_modulo = false"
                            >
                                <!-- CHIUDI DIALOG -->
                                <v-icon color="error"> mdi-close </v-icon>
                            </v-btn>
                        </template>
                        <span>Chiudi</span>
                    </v-tooltip>
                </v-toolbar>
                <v-row class="mx-3 mt-5" justify="center">
                    <v-col :cols="7">
                        <!-- IMMAGINE SFONDO MODULO -->
                        <v-img
                            class="mx-auto my-5"
                            max-width="300"
                            max-height="200"
                            contain
                            v-if="
                                background_image_modulo.sfondo &&
                                background_image_modulo.validita == 1
                            "
                            :src="background_image_modulo.sfondo"
                        />
                        <v-img
                            class="mx-auto my-5"
                            max-width="300"
                            max-height="200"
                            contain
                            v-else
                            :src="background_default"
                        />
                        <!-- ELIMINA IMMAGINE SFONDO MODULO -->
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                    v-bind="attrs"
                                    v-on="on"
                                    v-if="
                                        background_image_modulo.sfondo !=
                                            background_default &&
                                        background_image_modulo.validita == 1
                                    "
                                    small
                                    rounded
                                    @click="rimuoviImmagine()"
                                >
                                    <v-icon color="error"> mdi-close </v-icon>
                                </v-btn>
                            </template>
                            <span>Rimuovi Immagine</span>
                        </v-tooltip>
                    </v-col>
                    <!-- Visualizzazione Immagine Precedente,
          Visibile dopo aver inserito una nuova immagine -->
                    <v-col
                        v-if="
                            old_background_image_modulo.sfondo &&
                            old_background_image_modulo.validita == 1 &&
                            background_image_modulo.sfondo !=
                                old_background_image_modulo.sfondo
                        "
                        :cols="background_image_modulo.sfondo ? 4 : 8"
                    >
                        <span>Immagine Precedente:</span>
                        <v-img
                            class="mx-auto my-5"
                            max-width="300"
                            max-height="200"
                            contain
                            v-if="old_background_image_modulo != null"
                            :src="old_background_image_modulo.sfondo"
                        />
                        <span v-else>Immagine non trovata</span>
                    </v-col>
                </v-row>
            </v-card>
        </v-dialog>

        <!-- Snackbar -->
        <SnackbarQV ref="SnackbarQV" />
    </v-container>
</template>
<script>
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";
import background_default from "../../assets/Ind.jpg";

class ImmagineModulo {
    constructor(arg = undefined) {
        if (arg != undefined) {
            const campi = this.setCampi();
            campi.forEach((c) => {
                this[c.nome] =
                    arg[c.nome] != undefined ? arg[c.nome] : c.default_val;
            });
        } else {
            const campi = this.setCampi();
            campi.forEach((c) => {
                this[c.nome] = c.default_val;
            });
        }
    }
    // Metodo per resettare tutti i campi
    reset() {
        const campi = this.setCampi();

        campi.forEach((c) => {
            this[c.nome] = c.default_val;
        });
    }

    setCampi() {
        const campi = [
            { nome: "id_azienda_image", default_val: null },
            { nome: "id_modulo", default_val: null },
            { nome: "sfondo", default_val: "" },
            { nome: "validita", default_val: 1 },
        ];

        return campi;
    }
}
export default {
    name: "GestioneLayout",

    components: {
        SnackbarQV,
    },

    data() {
        return {
            // Variabili d'appoggio
            key_dialog_img_modulo: 0,
            testo_azienda: localStorage.testo_azienda,
            img_azienda: localStorage.img_azienda,
            id_azienda: localStorage.id_azienda,
            // Immagini
            background_default: background_default,
            background_image_modulo: new ImmagineModulo(),
            old_background_image_modulo: new ImmagineModulo(),
            // Modulo Selezionato
            selected_modulo: {},
            // Array
            moduli: [],
            // Boolean
            dialog_img_modulo: false,
        };
    },
    methods: {
        setAppBg() {
            const max_resolution = 1000;
            const that = this;
            const input = document.createElement("input");
            input.setAttribute("type", "file");
            input.setAttribute("accept", "image/png, image/jpeg");
            input.onchange = function () {
                const reader = new FileReader();
                reader.onload = function () {
                    const img = new Image();
                    img.onload = function () {
                        let width, height;
                        const ratio = img.width / img.height;
                        if (img.width > img.height) {
                            width = Math.min(max_resolution, img.width);
                            height = width / ratio;
                        } else {
                            height = Math.min(max_resolution, img.height);
                            width = height * ratio;
                        }
                        const canvas = document.createElement("canvas");
                        canvas.width = width;
                        canvas.height = height;
                        const ctx = canvas.getContext("2d");
                        ctx.drawImage(img, 0, 0, width, height);
                        that.immagine = ctx.canvas.toDataURL("image/jpeg", 0.8);
                        let request = {
                            controller: "global",
                            method: "PUT",
                            richiesta: {
                                action: "setsfondoapp",
                                token: localStorage.getItem("user_token"),
                                sfondo: ctx.canvas.toDataURL("image/jpeg", 0.8),
                            },
                        };
                        that.$store.dispatch("api6", request).then((res) => {
                            console.log(res);
                            that.$refs.SnackbarQV.print(
                                "success",
                                "Immagine di sfondo modificata con successo"
                            );
                        }).catch((e) => {
                            that.$refs.SnackbarQV.print(
                                "error",
                                e
                            );
                        });
                    };
                    img.src = reader.result;
                };
                reader.readAsDataURL(input.files[0]);
            };
            input.click();
        },
        // Seleziona modulo e apre il dialog di modifica sfondo
        selectModulo(item) {
            this.selected_modulo = JSON.parse(JSON.stringify(item));
            console.log(this.selected_modulo);
            this.getBackground(item.id_modulo);
            this.key_dialog_img_modulo =
                this.key_dialog_img_modulo == 0 ? 1 : 0;
            this.dialog_img_modulo = true;
        },
        // cambia l'immagine di sfondo del modulo
        cambiaImmagineModulo() {
            const max_resolution = 400;
            const input = document.createElement("input");
            input.setAttribute("type", "file");
            input.setAttribute("accept", "image/png, image/jpeg");
            input.onchange = () => {
                const reader = new FileReader();
                reader.onload = () => {
                    const img = new Image();
                    img.onload = function () {
                        let width, height;
                        const ratio = img.width / img.height;
                        if (img.width > img.height) {
                            width = Math.min(max_resolution, img.width);
                            height = width / ratio;
                        } else {
                            height = Math.min(max_resolution, img.height);
                            width = height * ratio;
                        }
                    };
                    this.background_image_modulo.validita = 1;
                    this.background_image_modulo.sfondo = reader.result;
                };
                reader.readAsDataURL(input.files[0]);
            };
            input.click();
        },
        // Cambia l'immagine dell'azienda
        cambiaImmagine() {
            const max_resolution = 400;
            const input = document.createElement("input");
            input.setAttribute("type", "file");
            input.setAttribute("accept", "image/png, image/jpeg");
            input.onchange = () => {
                const reader = new FileReader();
                reader.onload = () => {
                    const img = new Image();
                    img.onload = function () {
                        let width, height;
                        const ratio = img.width / img.height;
                        if (img.width > img.height) {
                            width = Math.min(max_resolution, img.width);
                            height = width / ratio;
                        } else {
                            height = Math.min(max_resolution, img.height);
                            width = height * ratio;
                        }
                    };
                    this.img_azienda = reader.result;
                };
                reader.readAsDataURL(input.files[0]);
            };
            input.click();
        },
        // Salva sfondo modulo
        salvaImmagineModulo() {
            console.log(this.selected_modulo.sfondo);
            this.background_image_modulo.id_modulo =
                this.selected_modulo.id_modulo;

            let request = {
                controller: "Token",
                method: "PUT",
                richiesta: {
                    action: "setbackgroundmodulo",
                    token: localStorage.getItem("user_token"),
                    tabella: [this.background_image_modulo],
                },
            };
            this.overlay = true;
            this.$store.dispatch("api", request).then((res) => {
                this.overlay = false;
                if (res.status == 200) {
                    this.getBackground(this.background_image_modulo.id_modulo);
                    this.$refs.SnackbarQV.print(
                        "success",
                        "Immagine di sfondo modificata con successo"
                    );
                } else {
                    this.$refs.SnackbarQV.print(
                        "orange",
                        "Errore di comunicazione col server, non è stato possibile caricare i dati."
                    );
                }
            });
        },
        // salva info azienda
        salva() {
            let request = {
                controller: "Token",
                method: "PUT",
                richiesta: {
                    action: "setinfoazienda",
                    token: localStorage.getItem("user_token"),
                    tabella: [
                        {
                            id_azienda: this.id_azienda,
                            testo_azienda: this.testo_azienda,
                            img_azienda: this.img_azienda,
                        },
                    ],
                },
            };
            this.overlay = true;
            this.$store.dispatch("api", request).then((res) => {
                this.overlay = false;
                if (res.status == 200) {
                    // this.getMacchine();
                    this.$refs.SnackbarQV.print(
                        "success",
                        "Modifiche eseguite con successo"
                    );
                } else {
                    this.$refs.SnackbarQV.print(
                        "orange",
                        "Errore di comunicazione col server, non è stato possibile caricare i dati."
                    );
                }
            });
        },
        getBackground(id) {
            this.background_image_modulo = new ImmagineModulo();
            let request = {
                controller: "Token",
                method: "POST",
                richiesta: {
                    action: "getbackgroundmodulo",
                    token: localStorage.getItem("user_token"),
                    id_modulo: id,
                },
            };
            this.overlay = true;
            this.$store.dispatch("api", request).then((res) => {
                this.overlay = false;
                if (res.status == 200) {
                    if (res.data.result.length > 0) {
                        this.background_image_modulo = res.data.result[0];
                        this.old_background_image_modulo = JSON.parse(
                            JSON.stringify(res.data.result[0])
                        );
                    } else {
                        this.background_image_modulo.sfondo =
                            background_default;
                        this.old_background_image_modulo.sfondo =
                            background_default;
                    }
                } else {
                    this.$refs.SnackbarQV.print(
                        "orange",
                        "Errore di comunicazione col server, non è stato possibile caricare i dati."
                    );
                }
            });
        },
        // rimuove le immagini visualizzate
        rimuoviImmagine() {
            if (
                // se la 'vecchia' immagine di sfondo e diversa dalla nuova
                this.old_background_image_modulo.sfondo !=
                this.background_image_modulo.sfondo
            ) {
                // la nuova viene copiata dalla vecchia
                this.background_image_modulo.sfondo =
                    this.old_background_image_modulo.sfondo;
            } else {
                // altrimenti se non ci sono immagini imposto la validita a 0 e salvo l'immagine,
                // in modo che venga visualizzata l'immagine di default
                this.background_image_modulo.validita = 0;
                this.salvaImmagineModulo();
            }
        },
    },
    mounted() {},
    created() {
        if (localStorage.moduli_sx !== "undefined")
            this.moduli = JSON.parse(localStorage.moduli_sx);
    },
};
</script>
<style>
.tokenImageProfile {
    border-radius: 0.5rem;
    height: 150px;
}
.pointer:hover {
    cursor: pointer;
}
</style>
